import React from 'react';
import Modal from 'react-bootstrap/Modal';
import './MileageConfirmation.scss';

interface FullJobImageProps {
    onClickShow: () => void;
    onClickHide: () => void;
    show: boolean;
    image: string;
    imageName: string;
}

const FullJobImage = ({ onClickHide, show, image, imageName }: FullJobImageProps): React.ReactElement => {
    return (
        <Modal size="lg" show={show} onHide={onClickHide}>
            <Modal.Header closeButton>
                <Modal.Title>{imageName}</Modal.Title>
            </Modal.Header>
            <img className="JobImage-Full" src={image} onClick={onClickHide} alt="" />
        </Modal>
    );
};

export default FullJobImage;

